import React from 'react';

export const NewCheckIcon = ({
  width = 24,
  height = 24,
  fill = 'black',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.86106 18.0009C9.72395 18.0004 9.58838 17.9718 9.4628 17.9168C9.33722 17.8617 9.2243 17.7814 9.13106 17.6809L4.27106 12.5109C4.08939 12.3173 3.99207 12.0594 4.00051 11.7941C4.00895 11.5287 4.12245 11.2776 4.31606 11.0959C4.50967 10.9142 4.76752 10.8169 5.03288 10.8253C5.29825 10.8338 5.54939 10.9473 5.73106 11.1409L9.85106 15.5309L18.2611 6.33089C18.3464 6.22461 18.4526 6.1369 18.5731 6.07315C18.6935 6.0094 18.8258 5.97095 18.9617 5.96017C19.0975 5.94938 19.2342 5.96649 19.3632 6.01044C19.4922 6.05439 19.6109 6.12425 19.7119 6.21573C19.813 6.30722 19.8943 6.41839 19.9508 6.54243C20.0073 6.66647 20.0378 6.80075 20.0406 6.93703C20.0433 7.0733 20.0181 7.2087 19.9666 7.3349C19.9151 7.4611 19.8384 7.57543 19.7411 7.67089L10.6011 17.6709C10.5087 17.7732 10.3962 17.8554 10.2706 17.9122C10.1449 17.969 10.0089 17.9992 9.87106 18.0009H9.86106Z"
      fill={fill}
    />
  </svg>
);

export const CheckXIcon = ({
  width = 13,
  height = 12,
  fill = '#EC5D52',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99689 6L12.1868 1.81011C12.3856 1.61161 12.4975 1.34224 12.4977 1.06127C12.498 0.780301 12.3866 0.51074 12.1881 0.311888C11.9896 0.113037 11.7202 0.00118391 11.4393 0.000935773C11.1583 0.000687639 10.8887 0.112065 10.6899 0.310565L6.5 4.50046L2.31011 0.310565C2.11125 0.111714 1.84155 0 1.56034 0C1.27912 0 1.00942 0.111714 0.810565 0.310565C0.611714 0.509417 0.5 0.779117 0.5 1.06034C0.5 1.34155 0.611714 1.61125 0.810565 1.81011L5.00046 6L0.810565 10.1899C0.611714 10.3887 0.5 10.6584 0.5 10.9397C0.5 11.2209 0.611714 11.4906 0.810565 11.6894C1.00942 11.8883 1.27912 12 1.56034 12C1.84155 12 2.11125 11.8883 2.31011 11.6894L6.5 7.49954L10.6899 11.6894C10.8887 11.8883 11.1584 12 11.4397 12C11.7209 12 11.9906 11.8883 12.1894 11.6894C12.3883 11.4906 12.5 11.2209 12.5 10.9397C12.5 10.6584 12.3883 10.3887 12.1894 10.1899L7.99689 6Z"
      fill={fill}
    />
  </svg>
);
